import React from 'react'
import { toIST, yyyyMmDd } from '@fareye/utils'
import { useTranslation } from '@fareye/common'

export function TripInfoWindow({ data }: { data: any }) {
  const { t } = useTranslation()
  return (
    <>
      <h5>
        <strong>{t('Trip Details')}</strong>
      </h5>
      <hr />
      <strong>{t('Vehicle No')}</strong>: {t(data.vehicleNo)}
      <br />
      <strong>{t('Route')}</strong>:
      {`${t(data.origin)} ${t('to')} ${t(data.destination)}`}
      <br />
      <strong>{t('S.T.A')}</strong>: {yyyyMmDd(toIST(data.eta))}
      <br />
      <strong>{t('Allow slip No')}</strong>: {t(data.invoiceNo)}
      <br />
      <strong>{t('Consigner')}</strong>: {t(data.consignerName)}
      <br />
      <strong>{t('Consignee')}</strong>: {t(data.consigneeName)}
      <br />
      <strong>{t('Vendor')}</strong>: {t(data.transporter)}
      <br />
      <strong>{t('Trip State')}</strong>: {t(data.state)}
      <br />
      <strong>{t('Status')}</strong>: {t(data.status)}
      <br />
      <strong>{t('Material')}</strong>: {t(data.material)}
      <hr />
      <strong>{t('Driver')}</strong>: {t(data.driverName)}
      <br />
      <strong>{t('Driver No')}</strong>: {t(data.driverPhoneNo)}
      <br />
    </>
  )
}
